/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";
import { PaymentsMenuList } from "./paymentsMenuList";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
            </span>
            <span className="menu-text">Início</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive('/clientes', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/clientes">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/General/User.svg')} />
            </span>
            <span className="menu-text">Clientes</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive('/users', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/users">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/General/User.svg')} />
            </span>
            <span className="menu-text">Usuários</span>
          </NavLink>
        </li>
        <PaymentsMenuList />
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive('/consultas', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/consultas">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/General/Search.svg')} />
            </span>
            <span className="menu-text">Consultas</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/chargebacks', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/chargebacks">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  '/media/svg/icons/Code/Warning-1-circle.svg',
                )}
              />
            </span>
            <span className="menu-text">Chargebacks</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/cancel', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/cancel">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  '/media/svg/icons/Code/Warning-1-circle.svg',
                )}
              />
            </span>
            <span className="menu-text">Cancelamentos</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/relatorios', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/relatorios">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl('/media/svg/icons/Shopping/Chart-line1.svg')}
              />
            </span>
            <span className="menu-text">Relatórios</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/produtos', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/produtos">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  '/media/svg/icons/Code/Warning-1-circle.svg',
                )}
              />
            </span>
            <span className="menu-text">Produtos</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/calculator-api', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/calculator-api">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl('/media/svg/icons/Shopping/Calculator.svg')}
              />
            </span>
            <span className="menu-text">Consumo API B2B</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive('/legal-documents', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/legal-documents">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Files/File.svg')} />
            </span>
            <span className="menu-text">Documentos legais</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
